import { useQuery } from "graphql-hooks";
import { Loading } from "../Shared/Loading";
import { ContentBlock } from "../Shared/Content/ContentBlock";
import { ContentBody } from "../Shared/Content/ContentBody";
import { useAPIErrorContext } from '../../contexts/apiErrorContext';

const CMS_QUERY = `query dataQuery {
  pageHomePage {
    fieldTestimonial {
      fieldName
      fieldOrganizationName
      fieldQuote
      fieldRole
    }
  }
}`;



export const Testimonial = () => {
    const { loading, error, data } = useQuery(CMS_QUERY, {
        variables: {
            limit: 10
        }
    });
    const { trackError } = useAPIErrorContext();

    if (!error && !loading) {
        let signature = data.pageHomePage.fieldTestimonial.fieldName;
        if (data.pageHomePage.fieldTestimonial.fieldRole != null && data.pageHomePage.fieldTestimonial.fieldRole != '') {
            signature += ', ' + data.pageHomePage.fieldTestimonial.fieldRole
        }
        if (data.pageHomePage.fieldTestimonial.fieldOrganizationName != null && data.pageHomePage.fieldTestimonial.fieldOrganizationName != '') {
            signature += ', ' + data.pageHomePage.fieldTestimonial.fieldOrganizationName
        }


        return (

            <ContentBlock className="homepageTestimonial">
                <ContentBody>
                    <div className="testimonialBody">
                        <div className="body" dangerouslySetInnerHTML={{ __html: data.pageHomePage.fieldTestimonial.fieldQuote }} />
                        <div className="signature">{signature}</div>
                    </div>
                </ContentBody>
            </ContentBlock>
        );
    }
    else if (!error) {
        return (<Loading showContent={false} includeHero={false} />);
    } else {
        trackError("Dato error", JSON.stringify(error));
        return (<> </>);
    }
};
